var API = wbsk_env.API;
const cartLocale = {
  nights:"Night(s)",
  days:"Giorni",
  deposit:"Acconto",
  people:"Persone"
}
wbskVirtualCart = (function(){
  var _this = {

    asCurreny:function(number){
      return `€${number}`
    },
    
    localStorageKey:'gmpcart3108', 
    
    set:function(data){
      localStorage.setItem(_this.localStorageKey,JSON.stringify(data))
    }, 
    
    // Get the proxy cart data from local storage
    get:function(){
      if(localStorage && localStorage.getItem(_this.localStorageKey)){
        return JSON.parse(localStorage.getItem(_this.localStorageKey))
      }else{
        var data = []
        _this.set(data)
        return data
      }
     
    },
    
    getTotal:function(items){
      var data = {total:0,deposit:0}
      items.forEach(function(item){
        data.total =  item.virtualCartData ? data.total + item.payment.subtotal : data.total + item.totalPrice
        data.deposit = item.virtualCartData ? data.deposit + item.payment.subtotal : data.deposit + item.depositPrice
      })     
      data = {
        total:formatAsMoneyFloat(data.total),
        deposit:Math.ceil(data.deposit)
      }
      return data
    },
    
    //add an item to the proxy cart
    addItems:function(items,showCart){
      var data = _this.get()
      data = data.concat(items.flat())
      _this.set(data)
      return data
    },
    
    // Remove an item from the proxy cart
    removeItem:function(index){
      var data = _this.get()
      data.splice(index,1)
      this.set(data)
    },
    
    // check avls of booking items
    checkBookingAvailability:function(items){
      var _this = this
      return new Promise(function(resolve,reject){
        var data = items,
            params = {
              method:'POST',
              headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            }
        params.body = JSON.stringify(data)
        fetch(`${API}/apiv1/storefront/checkBookingAvailability`,params).then(function(response){
          response.json().then(function(data){
            resolve(data)
          })
        })
      })
    },
  }
  return _this
})();


wbskShopifyCart = (function(){
  var _this = {
      
    clear:function(){
      return fetch('/cart/clear')
    },
    
    add:function(variantId,items){
      //clear cart double-down
      _this.clear() 
      return new Promise(function(resolve,reject){
        var data = {},
            lineItem = {},
            params
     
        lineItem.id = variantId 
        lineItem.quantity = 1
        lineItem.properties = {}
        items.forEach(function(item,index){
          if(item.virtualCartData){
            lineItem.properties[index+1] = `${item.excursionTitle} - ${item.eventTitle} x ${item.line_items.length} ticket(s) | ${item.eventDate} [${item.eventStartTime} - ${item.eventEndTime}]`
          }else{
            lineItem.properties[index+1] = `${item.productName} [${item.variantName} | ${item.length} ${item.productType != 'Hire Location' ? `${cartLocale.nights}` : `${cartLocale.days}`} | ${item.checkInPretty} - ${item.checkOutPretty}]`
          }
        })
        data.items = [lineItem]
        data.attributes = {}
        data.attributes.bookings = JSON.stringify(items)
        params = {
              method:'POST',
              headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            }
        params.body = JSON.stringify(data)
        fetch('/cart/add.js',params).then(function(response){
          response.json().then(function(responseData){
            resolve(responseData.items[0])
          })
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    
    createVariant:function(items){
      var _this = this
      return new Promise(function(resolve,reject){
        var data = {},
            params = {},
            prices = wbskVirtualCart.getTotal(items)
        data.items = items 
        data.totalPrice = prices.deposit
        params.method = 'POST'
        params.body = JSON.stringify(data)
        params.headers = {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
        }
        fetch(`${API}/apiv1/createVariant`,params).then(function(response){
          response.json().then(function(data){
            resolve(data)
          })
        }).catch(err =>{
          reject(err)
        })
      })
    },

    goToCheckout:function(){
      return new Promise( async function(resolve,reject){
         //get the cart items
         var items = wbskVirtualCart.get()
         //check the variants are still avl
         wbskVirtualCart.checkBookingAvailability(items).then(function(data){
           
           //_this.container.removeClass(_this.loadingClass)
           //if still avl, create product and atc
           if(!data.rejectedBookings.length && !data.tickets.rejected.length){
             _this.createVariant(items).then(function(variant){
               _this.clear().then(function(){
                _this.add(variant.id,items).then(function(cart){
                  resolve(cart)                 
                })
              }).catch(err => {
                console.log(err)
                reject(err)
              })
              
            }).catch(err => {
              reject(err)
            })
           }else{
             reject(data)
           }
         
        })
      })
    }
  }
  
  return _this
})();

(function($, window, undefined) {

  var defaults = {
    locale:cartLocale,
  }

  function wbsksidebarCart(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  wbsksidebarCart.prototype = {
    init: function() {  
      var _this = this
      this.dispatcher = $({})
      this.loadingClass = 'wbsk-ui-loader'
      this.wrapper = this.element.find('.js-wbsk-cart__wrapper')
      this.container = this.element.find('.js-wbsk-cart__container')
      this.openCtrl = this.element.find('.js-wbsk-cart__open')
      this.closeCtrl = this.element.find('.js-wbsk-cart__close')
      this.items = this.element.find('.js-wbsk-cart__items')
      this.empty = this.element.find('.js-wbsk-cart__empty')
      this.actions = this.element.find('.js-wbsk-cart__actions')
      this.rowClass = 'wbsk-ui-cart-row'
      this.counter = this.element.find('.js-wbsk-cart__counter')
      this.total = this.element.find('.js-wbsk-cart__total')
      this.deposit = this.element.find('.js-wbsk-cart__deposit')
      this.checkout = this.element.find('.js-wbsk-cart__checkout')
      this.removeItemCtrlClass = '.js-wbsk-cart__removeItem'
      //bind events
      this.bind(_this)
      //build the cart
      this.update()
      //empty the cart to stop multiple line items
      //this.clearCart()   
    },
    
    //bind click events
    bind:function(_this){
      this.openCtrl.click(function(e){
        e.preventDefault()
        _this.openCart()
      })
      
      this.closeCtrl.click(function(e){
        e.preventDefault()
        _this.closeCart()
      })
      
      this.checkout.click(function(e){
        e.preventDefault()
        _this.goToCheckout()
      })
      
      $(document).on('click',this.removeItemCtrlClass,function(e){
        var index = parseInt($(this).attr('data-js-wbsk-cart__index'))
        wbskVirtualCart.removeItem(index)
        _this.update()
        _this.dispatcher.trigger('itemRemoved')
      })
    },
    
    //open / close
    openCart:function(){
      this.wrapper.fadeIn(200)
      this.element.addClass('wbsk-cart-is-open')
    },
    
    closeCart:function(){
      this.wrapper.fadeOut(200)
      this.element.removeClass('wbsk-cart-is-open')
    },
    
    //add an item to the proxy cart
    addToVirtualCart:function(items,showCart){
      var _this = this
      wbskVirtualCart.addItems(items)
      _this.update()
      _this.openCart()
      _this.dispatcher.trigger('itemAdded')
    },
   
    buildRow:function(item,index){
      let row
      if(item.virtualCartData){
        row = `<div class="${this.rowClass} flex row-wrap align-center justify-left bdr-b bdr-grey ct cb cell-l cell-r">
                <a href="${item.virtualCartData.productHandle}" class="block-3/12 far-image far-image--square block-rel">
                  <img src="${item.virtualCartData.image.src}">
                </a>
                <div class="cell-l block-9/12">
  		         <h3 class="h-style h5-style row--xs t-accent"><a href="${item.virtualCartData.productHandle}">${item.excursionTitle} - ${item.eventTitle}</a></h3>
                 <h4 class="h-style h7-style row--s">${item.eventDate} (${item.eventStartTime} ${item.eventEndTime})</h4>
                 <span class="t-small t-grey d-block row--s">${wbskVirtualCart.asCurreny(item.payment.subtotal)}</span>
                 <ul>${item.displayLineItems.map( display_item => `<li class="row--xs t-xs">${display_item.qty} x ${display_item.title} - ${wbskVirtualCart.asCurreny(display_item.price)}</li>`).join('')}</ul>
  		         <button data-js-wbsk-cart__index=${index} class="js-wbsk-cart__removeItem btn-reset t-small t-accent"><u>Remove</u></button>
               </div>
             </div>` 
      }else{
        row = `<div class="${this.rowClass} flex row-wrap align-center justify-left bdr-b bdr-grey ct cb cell-l cell-r">
                <a href="/products/${item.productHandle}" class="block-3/12 far-image far-image--square block-rel">
                  <img src="${item.image}">
                </a>
                <div class="cell-l block-9/12">
			     <h3 class="h-style h5-style row--xs t-accent"><a href="/products/${item.productHandle}">${item.productName}</a></h3>
                     <h4 class="h-style h7-style row--s">${item.variantName}</h4>
                     <span class="t-small t-grey d-block row--xs">
				     ${wbskVirtualCart.asCurreny(item.basePrice)} ${item.productType != 'Hire Location' ? `for ${item.length} ${this.settings.locale.nights} / ${item.numAdult+item.numChild} ${this.settings.locale.people}` : `for ${item.length} ${this.settings.locale.days}`}
                     </span>
                     ${item.upsells && item.upsells.length > 0 ? `<span class="t-small t-grey d-block row--xs">${wbskVirtualCart.asCurreny(item.upsellsPrice)} add-ons</span>` : '' }
                     ${item.depositPrice != item.totalPrice ? `<span class="t-small t-grey d-block row--xs"> ${this.settings.locale.deposit}: ${wbskVirtualCart.asCurreny(item.depositPrice)}</span>` :''}
                     <span class="t-small  t-grey d-block row">${item.checkInPretty} - ${item.checkOutPretty}</span>
			     <button data-js-wbsk-cart__index=${index} class="js-wbsk-cart__removeItem btn-reset t-small t-accent"><u>Remove</u></button>
               </div>
             </div>` 
      }
      return row
    },
    
    update:function(){
      var _this = this
      var lineItems =  wbskVirtualCart.get() 
      _this.counter.text(lineItems.length)
      var prices = wbskVirtualCart.getTotal(lineItems)
        _this.total.text(wbskVirtualCart.asCurreny(prices.total))
        _this.deposit.text(wbskVirtualCart.asCurreny(prices.deposit))
      if(lineItems && lineItems.length > 0 ){
        _this.items.show()
        _this.actions.show()
        _this.empty.hide()
        _this.items.empty()
        lineItems.forEach(function(item,index){
          _this.items.append(_this.buildRow(item,index))
        })
      }else{
        _this.items.hide()
        _this.actions.hide()
        _this.empty.show()
      }
    },
      
    //// Checkout
    //click handler
    goToCheckout:function(){
      var _this = this;
      _this.container.addClass(_this.loadingClass)
      wbskShopifyCart.goToCheckout().then(function(cart){
        if(cart && cart.price){
          window.location.href = '/checkout'
        }else{
          console.log(cart)
        }    
      }).catch(function(error){
        _this.container.removeClass(_this.loadingClass)
      })
    },
  }

  $.fn.wbsksidebarCart = function(settings) {
    $.data($(this)[0], 'wbsksidebarCart', new wbsksidebarCart(this, settings))
  }

}(jQuery, window));


//// Quant selectors
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function qntSel(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  qntSel.prototype = {
  
    init: function() {      
      var _this = this
      this.minus = this.element.find('span').first(),
      this.plus = this.element.find('span').last(),
      this.input = this.element.find('input')   
      this.min = 0
      this.max = Math.pow(10, 1000) 
      
      if(this.input.attr('min')){
        this.min = this.input.attr('min')
      }
      
      if(this.input.attr('max')){
        this.max = this.input.attr('max')
      }
  
      //bind handlers
      this.minus.on('click', function(e) {
        _this.updateValue('minus')
      })
      this.plus.on('click', function(e) {
        _this.updateValue('plus')
      }) 
      this.input.on('change', function(e) {
        //change hanlder
      }) 
    },
    
    updateValue:function(math){
      var a = parseInt(this.input.val()),
          p1 = a + 1,
          m1 = a - 1
         
      if(math == 'plus' && p1 <= this.max){
        this.input.val(p1).trigger('change')
      }
      if(math == 'minus' && m1 >= this.min){
        this.input.val(m1).trigger('change')
      }
    },
  }

  $.fn.qntSel = function(settings) {
    return this.each(function () {
      $.data(this, 'qntSel', new qntSel(this, settings))
    })
  }

}(jQuery, window));








